import { motion } from "framer-motion"; // Importa motion desde framer-motion
import '../loading.css'; 
import logoWhite from "../.././src/assets/7.png";
import logoBlack from "../../src/assets/HarmaLogo.png"
import { useSelector } from "react-redux";

export default function Loading() {
  const { isDarkMode } = useSelector((state) => state.darkMode);

  return (
    <div className="w-full h-screen bg-background flex flex-col items-center justify-center">
     
      {!isDarkMode && (
        <motion.img
        className="w-[700px]"
        src={logoBlack}
        alt="Logo"
        animate={{
          scale: [1, 1.2, 1], 
        }}
        transition={{
          duration: 2, 
          repeat: Infinity, 
          ease: "easeInOut", 
        }}
      />
      )}

      {isDarkMode && (
        <motion.img
        className="w-[700px]"
        src={logoWhite}
        alt="Logo"
        animate={{
          scale: [1, 1.2, 1], 
        }}
        transition={{
          duration: 2, 
          repeat: Infinity, 
          ease: "easeInOut", 
        }}
      />
      )}
      
      <h1 className="loading-text text-text">
        Loading
        <span className="dot">.</span>
        <span className="dot">.</span>
        <span className="dot">.</span>
      </h1>
    </div>
  );
}